__turbopack_context__.v({
  "active": "YBrNdq_active",
  "animated": "YBrNdq_animated",
  "carousel": "YBrNdq_carousel",
  "carouselContainer": "YBrNdq_carouselContainer",
  "carouselPanel": "YBrNdq_carouselPanel",
  "centerTitles": "YBrNdq_centerTitles",
  "context": "YBrNdq_context",
  "controls": "YBrNdq_controls",
  "controlsContainer": "YBrNdq_controlsContainer",
  "indicator": "YBrNdq_indicator",
  "indicators": "YBrNdq_indicators",
  "item": "YBrNdq_item",
  "itemFlex2": "YBrNdq_itemFlex2",
  "itemFlex3": "YBrNdq_itemFlex3",
  "itemFlex4": "YBrNdq_itemFlex4",
  "link": "YBrNdq_link",
  "paddingBottom0": "YBrNdq_paddingBottom0",
  "paddingBottom112": "YBrNdq_paddingBottom112",
  "paddingBottom128": "YBrNdq_paddingBottom128",
  "paddingBottom16": "YBrNdq_paddingBottom16",
  "paddingBottom32": "YBrNdq_paddingBottom32",
  "paddingBottom48": "YBrNdq_paddingBottom48",
  "paddingBottom64": "YBrNdq_paddingBottom64",
  "paddingBottom80": "YBrNdq_paddingBottom80",
  "paddingBottom96": "YBrNdq_paddingBottom96",
  "paddingTop0": "YBrNdq_paddingTop0",
  "paddingTop112": "YBrNdq_paddingTop112",
  "paddingTop128": "YBrNdq_paddingTop128",
  "paddingTop16": "YBrNdq_paddingTop16",
  "paddingTop32": "YBrNdq_paddingTop32",
  "paddingTop48": "YBrNdq_paddingTop48",
  "paddingTop64": "YBrNdq_paddingTop64",
  "paddingTop80": "YBrNdq_paddingTop80",
  "paddingTop96": "YBrNdq_paddingTop96",
  "subtitle": "YBrNdq_subtitle",
  "title": "YBrNdq_title",
});
